<div class="content-heading">
  <div class="header-container">
    <h3>Productos Temporales</h3>
    <small>Catálogo de Productos que no se encuentran dentro del sistema de CEQ</small>
  </div>
</div>

<div class="container-fluid">
  <div class="row">
    <div class="col-lg-12">
      <div class="card card-default">
        <div class="card-body">
          <div class="row">
            <div class="col-md-12 col-xs-12">

              <div class="row filter-container d-flex align-items-end mb-2">
                <div class="col-12 col-md-4">
                  <aph-custom-text label="Código" placeholder="Buscar por código..." [(ngModel)]="productCode"
                    (ngModelChange)="getProduct()">
                  </aph-custom-text>
                </div>
                <div class="col-12 col-md-4">
                  <aph-custom-text label="Nombre" placeholder="Buscar por nombre..." [(ngModel)]="productName"
                    (ngModelChange)="getProduct()">
                  </aph-custom-text>
                </div>
                <div class="ml-auto mr-3">
                  <aph-custom-buttons type="button" preset="refresh" (btnClick)="refresh()" style="margin-bottom: 8px;"></aph-custom-buttons>
                </div>
              </div>
              <div class="row">
                <app-ceq-table class="col-12" #CeqGrid [gridAdditionalOptions]="gridOptions" [columnDef]="columnDefs"
                  (apiEmitter)="gridEmiter($event)">
                </app-ceq-table>
              </div>
            </div>
            <div class="col-md-12 col-xs-12 mt-3">
              <div class="pagesize-control">
                Tama&ntilde;o de p&aacute;gina:
                <select (change)="onPageSizeChange($event.target.value)">
                  <option *ngFor="let size of pageSizes" [ngValue]="size">{{size}}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>